import React from "react";

import edu from "../assets/images/icons/color-03.svg";
import Moment from "react-moment";
import { PuzzleIcon } from '@heroicons/react/solid';
function ExtraCur({ data }) {
  return (
    <>
      <div className="px-2 px-md-4 rounded shadow py-2 py-md-3 bg-white mb-3">
        <div>
          <div className="backgroundHead flex items-center mb-3">
          <PuzzleIcon className=" w-6 text-gray-700"/>
            <span className="block ml-2 manpro font-medium uppercase text-gray-500">
              Extra Curriculam
            </span>
          </div>
          {data.map((data, idx) => {
            return (
              <div key={idx} className="stats-container">
                <div></div>
                <div className="summaryInfo ml-2 md:ml-5">
                  <div className="flex relative pb-6">
                    <div className="circle relative"></div>
                    <div className="timeline-show"></div>
                    <div className="flex-1 ml-2">
                    <small className="block manpro font-regular text-gray-400">
                        <Moment format={"YYYY"}>
                          {data.start_date}
                        </Moment> - {data.end_date === null || data.currently_working === "1" ? "Present" : <Moment format={"YYYY"}>
                          {data.end_date}
                        </Moment>} 
                      </small>

                      <span
                        className="block manpro font-semibold text-sm :md:text-base"
                        style={{ color: "var(--color-5)" }}
                      >
                        {data.title}
                      </span>
                      <a
                        href={data.project_url}
                        className="block manpro font-medium text-sm :md:text-base"
                      >
                        {data.project_url}
                      </a>
                    </div>
                    <div className="w-14 h-14 md:w-20 md:h-20 inline-block border rounded-xl overflow-hidden">
                      {data.media_privacy === "1" && data.extrac_media ? (
                        <img
                          src={data.extrac_media}
                          alt="edu"
                          className="w-full p-2"
                        />
                      ) : (
                        <PuzzleIcon className="w-full p-3 text-gray-700"/>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default ExtraCur;
